<template>
    <section class="section modal-fields">
        <div class="title has-text-centered">{{ withAuth ? "Je m'inscris" : "Finaliser la réservation" }}</div>
        <div class="form-fields">
            <div class="field" v-for="(field, index) in fields" :key="index">
                <label class="label">{{field.name}} <span v-if="field.required">*</span> </label>
                <div class="control">
                    <input
                        @input="formatPhone"
                        class="input is-rounded"
                        type="tel"
                        maxlength="14"
                        :placeholder="field.description??''"
                        v-if="'telephone' === field.data_type"
                        :required="!!field.required"
                        :id="`field-${field.internal_col_name}`"
                        :field_name="field.internal_col_name"
                    >
                    <input
                        class="input is-rounded"
                        :type="field.data_type"
                        :placeholder="field.description??''"
                        v-else-if="['text', 'email', 'date', 'number'].includes(field.data_type)"
                        :required="!!field.required"
                        :id="`field-${field.internal_col_name}`"
                        :field_name="field.internal_col_name"
                    >
                    <textarea
                        v-else-if="field.data_type === 'textarea'"
                        name=""
                        class="textarea is-rounded"
                        :required="!!field.required"
                        :id="`field-${field.internal_col_name}`"
                        :field_name="field.internal_col_name"
                        :placeholder="field.description??''"
                    ></textarea>
                    <div
                        class="select is-rounded is-flex-grow-1 is-flex"
                        v-if="field.data_type === 'select'"
                    >
                        <select name="" :id="`field-${field.internal_col_name}`" :required="!!field.required" class="is-flex-grow-1" :field_name="field.internal_col_name">
                            <option value=""></option>
                            <option v-for="(option, index) in field.options" :key="index" :value="option.value">{{option.label}}</option>
                        </select>
                    </div>
                    <div v-else-if="field.data_type === 'checkbox'" :id="`field-${field.internal_col_name}`">
                        <div v-for="(option, index) in field.options" :key="index">
                            <label :for="`option-${field.efs_is}-${option.value}`" class="checkbox" >
                                <input
                                    type="checkbox"
                                    :name="field.internal_col_name"
                                    :id="`option-${field.efs_is}-${option.value}`"
                                    :value="option.value"
                                    :field_name="field.internal_col_name"
                                >
                                {{option.label}}
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="withAuth" class="field column is-full-desktop">
                <label for="password" class="label">Mot de passe * (5 caractères minimum)</label>
                <div class="control">
                    <input :class="password_error ? 'input is-danger is-rounded' : 'input is-rounded'" type="password" name="" id="password" v-model="password" autocomplete="off">
                </div>
            </div>
            <div v-if="withAuth" class="field column is-full-desktop">
                <label for="password-confirm" class="label">Confirmation de mot de passe *</label>
                <div class="control">
                    <input :class="password_confirm_error ? 'input is-danger is-rounded' : 'input is-rounded'" type="password" name="" id="password-confirm" v-model="password_confirm" autocomplete="off">
                </div>
            </div>
        </div>
        <p class="help">Les champs marqués d'un * sont obligatoires.</p>
        <br>
        <p class="help" style="display: flex; align-items: center;"><input type="checkbox" v-model="aggreement">&nbsp;<a href="https://mysimplyagenda.com/CGU_FO_My_Simply_Agenda.pdf">J'ai bien pris en compte et accepte les conditions générales d'utilisation</a></p>
        <p class="help">Les données personnelles enregistrées à partir de vos réponses font l'objet d'un traitement informatique. Le droit de la protection des données vous garantit un droit d'accès et de rectification de vos données. <a target="_blank" rel="noopener noreferrer" href="https://www.mysimplyagenda.com/Politique_de_confidentialite_FO_My_Simply_Agenda.pdf">En savoir plus </a></p>
        <br>
        <p class="help is-danger is-size-6">
            {{error_message}}
        </p>
        <div v-if="withAuth" class="buttons is-justify-content-center">
            <button id="btn-signup" :class="is_loading ? 'button is-loading is-info is-rounded' : 'button is-info is-rounded'" @click="save">M'inscrire</button>
        </div>
        <div v-else class="buttons is-justify-content-space-between">
            <button :class="is_loading ? 'button is-loading is-info is-rounded' : 'button is-info is-rounded'" @click="saveWithoutAuth">Enregistrer</button>
            <button :class="is_loading ? 'button is-loading is-info is-rounded' : 'button is-light is-rounded'" @click="cancel">annuler</button>
        </div>
        <p v-if="withAuth" class="help has-text-centered">
            Déjà un compte ?
            <span class="is-clickable has-text-info" @click="$emit('showSignIn')">
                Je me connecte
            </span>
        </p>

    </section>
</template>
<script>
import axios from 'axios'
import { Inertia } from '@inertiajs/inertia'
import {toast} from 'bulma-toast'
export default {
    name: 'SignIn',
    props: ["withAuth"],
    emits: ['submitWithoutAuth'],
    data () {
        return {
            email: null,
            error_message: null,
            fields: [],
            is_loading: false,
            password: null,
            password_error: false,
            password_confirm: null,
            password_confirm_error: false,
            aggreement: false
        }
    },
    methods : {
        formatPhone(ev){
            let input = ev.target;
            let digits =  ev.target.value.replaceAll(/[^0-9]/g,'')?.match(/.{1,2}/g)?.join('.') ?? '';
            input.value = digits;
        },
        toggleModal () {
            if (this.is_loading) return false
            let modal = document.querySelector('#auth-modal')
            modal.classList.toggle('is-active')
        },
        getFields () {
            axios.get('/client/informations').then(response => {
                // this.fields = response.data.sort((a, b) => a.position > b.position);
                this.fields = response.data.fields.sort((a, b) => a.position - b.position);
            })
        },
        getFieldValue (field) {
            return this.user[field.internal_col_name] ?? ''
        },
        getIsChecked (field, option) {
            if (!this.user[field.internal_col_name]) return false
            return this.user[field.internal_col_name].split(',').includes(option)
        },
        passwordValid () {
            this.password_error = false
            this.password_confirm_error = false
            this.error_message = ''
            if (!this.password || this.password.length < 5) {
                this.password_error = true
                this.error_message = 'Le mot de passe doit contenir au moins 5 caractères.'
            }
            if (this.password != this.password_confirm) {
                this.password_confirm_error = true
                this.error_message ||= 'Les mots de passe ne sont pas identiques.'
            }
            if (this.password_error || this.password_confirm_error) {
                return false
            }
            return true
        },
        aggreementValid() {
            if(!this.aggreement){
                this.error_message = "Veuillez accepter les conditions générales d'utilisation en cochant la case";
                return false;
            }
            return true;
        },

        validateDynamiqueField(){
            if (this.is_loading) return false

            let fields = document.querySelectorAll('.modal-fields [field_name]')
            let data = {}
            for (let field of fields) {
                if (field.getAttribute('type') === 'checkbox' && !field.checked) continue
                let field_name = field.getAttribute('field_name')
                let elt = data[field_name]||[]
                if (field.value) elt.push(field.value)
                data[field_name] = elt
            }
            for (let key in data) {
                let field = this.fields.find(field => field.internal_col_name === key)
                if (field.data_type !== "checkbox") data[key] = data[key].toString()
                if (field.required && !data[key]) {
                    let field_name = field.name ? field.name?.toLowerCase() : null
                    this.error_message =
                        field_name ?
                        `Le champ "${field_name}" est obligatoire.` :
                        "Merci de renseigner tous les champs obligatoires."
                    return false
                }
                if(field.data_type === 'date'){
                    let result = /^(\d{4})-(\d{2})-(\d{2})$/.exec(data[key]);
                    if (result){
                        data[key] = `${result[3]}/${result[2]}/${result[1]}`
                    }else if(/^\d{2}\/\d{2}\/\d{4}$/.test(data[key])){
                    }else{
                        let field_name = field.name.toLowerCase()
                        this.error_message =  `Le champ "${field_name}" doit être une date valide.`
                        return false
                    }
                }
            }
            return data;
        },

        save () {
            if (this.is_loading) return false

            let fields = document.querySelectorAll('.modal-fields [field_name]')
            let data = {}
            for (let field of fields) {
                if (field.getAttribute('type') === 'checkbox' && !field.checked) continue
                let field_name = field.getAttribute('field_name')
                let elt =
                    data[field_name]
                    ||
                    []
                if (field.value) elt.push(field.value)
                data[field_name] = elt
            }
            for (let key in data) {
                let field = this.fields.find(field => field.internal_col_name === key)
                if (field.data_type !== "checkbox") data[key] = data[key].toString()
                if (field.required && !data[key]) {
                    let field_name = field.name ? field.name?.toLowerCase() : null
                    this.error_message =
                        field_name ?
                        `Le champ "${field_name}" est obligatoire.` :
                        "Merci de renseigner tous les champs obligatoires."
                    return false
                }
                if(field.data_type === 'date'){
                    let result = /^(\d{4})-(\d{2})-(\d{2})$/.exec(data[key]);
                    if (result){
                        data[key] = `${result[3]}/${result[2]}/${result[1]}`
                    }else if(/^\d{2}\/\d{2}\/\d{4}$/.test(data[key])){
                    }else{
                        let field_name = field.name.toLowerCase()
                        this.error_message =  `Le champ "${field_name}" doit être une date valide.`
                        return false
                    }
                }
            }

            if (!this.passwordValid()) return false

            if(!this.aggreementValid()) return false;

            data.password = this.password
            data.password_confirm = this.password_confirm
            this.error_message = null
            this.is_loading = true
            axios.post('/client', data).then(response => {
                this.is_loading = false
                toast({
                    message: response?.data?.message || 'Inscription réussie.',
                    type: 'is-success',
                    duration: 3000,
                    pauseOnHover: true
                })
                Inertia.reload({ only: ['auth.user'] })
                this.toggleModal()
            }).catch(err => {
                this.is_loading = false
                if (err?.response?.data?.errors) {
                    for (let error in err?.response?.data?.errors) {
                        err.response.data.errors[error].forEach(message => {
                            toast({
                                message: message,
                                type: 'is-danger',
                                duration: 8000,
                                pauseOnHover: true
                            })
                        });
                    }
                } else {
                    toast({
                        message: err.response?.data?.message  ?? 'Vos changements n\'ont pas pu être pris en compte.',
                        type: 'is-danger',
                        duration: 8000,
                        pauseOnHover: true
                    })
                }
            })
        },

        saveWithoutAuth() {
            let data = this.validateDynamiqueField();
            if(!this.aggreementValid()) return false;
            if(data != false){
                this.$emit("submitWithoutAuth", data);
                this.toggleModal();
            }else{
                return false;
            }
        },

        cancel() {
            this.$inertia.get("/ressources");
        }
    },
    mounted () {
        if (!this.$page.props.config.disabled_fo_signup) this.getFields()
    }
}
</script>

<style scoped>
    .datetimepicker-dummy .datetimepicker-dummy-wrapper {
        border-radius: 20px;
    }

    #btn-signup {
        background-color: var(--btn-primary-bg-color);
        color: var(--btn-primary-text-color);
    }

    #btn-signup:hover {
        background-color: var(--btn-primary-bg-color-hover);
        color: var(--btn-primary-text-color);
    }
</style>
